import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './PREFEQ_Lifecycle_Milestone_S.css';

const PREFEQ_Lifecycle_Milestone_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Preferred Equity Token Lifecycle Milestone');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_LIFECYCLE_MILESTONE/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/PREFEQ_Lifecycle_Milestone', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_${i}_SECTION`;
	  const headerId = `#PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_LIFECYCLE_MILESTONE/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/PREFEQ_Lifecycle_Milestone',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [PREFEQ_LIFECYCLE_MILESTONE, setPREFEQ_LIFECYCLE_MILESTONE] = React.useState(null);
  const [PREFEQ_LIFECYCLE_MILESTONE_S, setPREFEQ_LIFECYCLE_MILESTONE_S] = React.useState(null);

  var Ids = [];
  for(var Ele in PREFEQ_LIFECYCLE_MILESTONE_S){
	  for(var Sec in PREFEQ_LIFECYCLE_MILESTONE_S[Ele]){
			if(Sec == "id")
				Ids.push(PREFEQ_LIFECYCLE_MILESTONE_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(PREFEQ_LIFECYCLE_MILESTONE_S[Ele]["status"]);
			else if(Array.isArray(PREFEQ_LIFECYCLE_MILESTONE_S[Ele][Sec]))
				  for(var Row in PREFEQ_LIFECYCLE_MILESTONE_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in PREFEQ_LIFECYCLE_MILESTONE_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_LIFECYCLE_MILESTONE`).then((response) => {
      setPREFEQ_LIFECYCLE_MILESTONE(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPREFEQ_LIFECYCLE_MILESTONE_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!PREFEQ_LIFECYCLE_MILESTONE_S) return <div>Loading...</div>;

 const handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S = async (data) => {
  };




  const handleAddPREFEQ_LIFECYCLE_MILESTONE_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_LIFECYCLE_MILESTONE_S', JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREFEQ_LIFECYCLE_MILESTONE_S');
      setPREFEQ_LIFECYCLE_MILESTONE_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  

const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4"]=value;
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddPREFEQ_LIFECYCLE_MILESTONE(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE']);
  }; 
  

    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["1"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("1","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["2"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0"]=value;
	Form_Data_onChange("2","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0",value,Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
  }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["2"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1"]=value;
	Form_Data_onChange("2","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1",value,Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
  }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["2"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2"]=value;
	Form_Data_onChange("2","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2",value,Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
  }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["2"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3"]=value;
	Form_Data_onChange("2","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3",value,Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
  }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["3"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("3","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["3"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("3","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  

const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE));
	Temp_Data["4"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0"]=value;
	Form_Data_onChange("4","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddPREFEQ_LIFECYCLE_MILESTONE(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE']);
  }; 
  


const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE));
	Temp_Data["9"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0"]=value;
	Form_Data_onChange("9","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE(Temp_Data);
	//handleAddPREFEQ_LIFECYCLE_MILESTONE(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE']);
  }; 
  

    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["9"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("9","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["9"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("9","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["9"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("9","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  
    
const PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREFEQ_LIFECYCLE_MILESTONE_S));
	Temp_Data["9"]["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4"]=value;
	//handleAddPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data,App_Data['PREFEQ_LIFECYCLE_MILESTONE_S']);
	Form_Data_onChange("9","PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4",value,Temp_Data);
 	//handleLastDataPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
    setPREFEQ_LIFECYCLE_MILESTONE_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = PREFEQ_LIFECYCLE_MILESTONE_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Preferred Equity Token Lifecycle Milestone')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREFEQ Milestone ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0" type="text" className="form-control" placeholder="PREFEQ Milestone ID"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREFEQ Milestone ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1" type="text" className="form-control" placeholder="Asset ID"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2" type="text" className="form-control" placeholder="Offering ID"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3" type="text" className="form-control" placeholder="Milestone Name"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Milestone Name`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Milestone Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4"   onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4_Change} className="form-control" name="Milestone Type"  >
						  <option value="Legal">Legal</option>
						  <option value="Funding">Funding</option>
						  <option value="Construction">Construction</option>
						  <option value="Inspection">Inspection</option>
						  <option value="Rental Operations">Rental Operations</option>
						  <option value="Valuation">Valuation</option>
						  <option value="Distribution">Distribution</option>
						  <option value="Exit">Exit</option>
						  <option value="Auction">Auction</option>
						  <option value="Compliance">Compliance</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Milestone Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Milestone Order`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5" type="text" className="form-control" placeholder="Milestone Order"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Milestone Order`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Planned Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0" type="date"   
							onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0_Change} style={{ borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Planned Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Planned End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1" type="date"   
							onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1_Change} style={{ borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Planned End Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Actual Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2" type="date"   
							onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2_Change} style={{ borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Actual Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Actual End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3" type="date"   
							onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3_Change} style={{ borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Actual End Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Required Completion Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0" type="text" className="form-control" placeholder="Required Completion Percentage"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Required Completion Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Completion Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1" type="text" className="form-control" placeholder="Current Completion Percentage"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Current Completion Percentage`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Milestone Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0"   onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0_Change} className="form-control" name="Milestone Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Submitted for Inspection">Submitted for Inspection</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Released">Released</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Milestone Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0"   onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`PREFEQ Milestone ID`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Milestone Name`)}</th>
                        <th>{t(`Milestone Type`)}</th>
                        <th>{t(`Milestone Order`)}</th>
                        <th>{t(`Planned Start Date`)}</th>
                        <th>{t(`Planned End Date`)}</th>
                        <th>{t(`Actual Start Date`)}</th>
                        <th>{t(`Actual End Date`)}</th>
                        <th>{t(`Required Completion Percentage`)}</th>
                        <th>{t(`Current Completion Percentage`)}</th>
                        <th>{t(`Milestone Status`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {PREFEQ_LIFECYCLE_MILESTONE_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_0"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_1"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_2"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_3"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_4"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_1_5"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_0"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_1"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_2"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_2_3"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_0"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_3_1"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_4_0"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_0"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_1"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_2"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_3"]} </td>
						<td>{e["PREFERRED_EQUITY_07_ASSET_MANAGER_LIFECYCLE_EXIT_PREFEQ_LIFECYCLE_MILESTONE_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default PREFEQ_Lifecycle_Milestone_S;  